
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/quickEditEngine/components/styles/quickEditCompPanelWrapper.scss.css.virtualfile';
        module.exports = {"quickEditCompPanelWrapper":"_quickEditCompPanelWrapper_123mk_1","fullHeight":"_fullHeight_123mk_18"};